<template>
  <q-page padding>
    <h1>Welcome to the ICP Industry Account Page</h1>
  </q-page>
</template>

<script>

export default {
  name: 'PageHome'
}
</script>
